/** Endpoints #35-#38 — installed scraper plugins, their config, tests and slot binding. */

import type {
  ActiveScraperUpdateBody,
  ScrapersResponse,
  ScraperTestResponse,
} from '@lw/shared';
import { apiJson } from './client';

/** #35 `GET /api/scrapers` — plugins with their fields; secrets arrive masked (§10.3). */
export function getScrapers(signal?: AbortSignal): Promise<ScrapersResponse> {
  return apiJson<ScrapersResponse>('/scrapers', { signal });
}

/** #36 `PUT /api/scrapers/:id/config` — partial; an omitted secret keeps its stored value. */
export function updateScraperConfig(
  pluginId: string,
  config: Record<string, string | number | boolean>,
): Promise<ScrapersResponse> {
  return apiJson<ScrapersResponse>(`/scrapers/${encodeURIComponent(pluginId)}/config`, {
    method: 'PUT',
    body: { config },
  });
}

/** #37 `POST /api/scrapers/:id/test` — `{ok}` either way; never throws on bad credentials. */
export function testScraper(pluginId: string): Promise<ScraperTestResponse> {
  return apiJson<ScraperTestResponse>(`/scrapers/${encodeURIComponent(pluginId)}/test`, {
    method: 'POST',
  });
}

/** #38 `PUT /api/scrapers/active` — bind a plugin to its kind's slot, or `null` for None. */
export function setActiveScraper(body: ActiveScraperUpdateBody): Promise<ScrapersResponse> {
  return apiJson<ScrapersResponse>('/scrapers/active', { method: 'PUT', body });
}
